import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_SERVICE || 'https://api.musicologystudio.com';

export const postContact = async (data) => {
  const url = `https://wapi.musicologystudio.com/contact`;

  try {
    const response = await axios.post(url, data)
    return response.data;
  } catch (err) {
    console.error(err);
  }
};

// New API endpoints for AWS API Gateway
export const getApps = async () => {
  const url = `https://api.musicologystudio.com/apps`;

  try {
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.error('Error fetching apps:', err);
    return { count: 0, items: [] };
  }
};

export const getEducationals = async () => {
  const url = `https://api.musicologystudio.com/educationals`;

  try {
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.error('Error fetching educationals:', err);
    return { count: 0, items: [] };
  }
};

export const getPhotos = async () => {
  const url = `https://api.musicologystudio.com/photos`;

  try {
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.error('Error fetching photos:', err);
    return { count: 0, items: [] };
  }
};

export const getVideos = async () => {
  const url = `https://api.musicologystudio.com/videos`;

  try {
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.error('Error fetching videos:', err);
    return { count: 0, items: [] };
  }
};

export const getMaterials = async () => {
  const url = `https://api.musicologystudio.com/materials`;

  try {
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.error('Error fetching materials:', err);
    return { count: 0, items: [] };
  }
};

export const getPastEvents = async () => {
  const url = `https://api.musicologystudio.com/events/past`;

  try {
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.error('Error fetching past events:', err);
    return { count: 0, items: [] };
  }
};

export const getUpcomingEvents = async () => {
  const url = `https://api.musicologystudio.com/events/upcoming`;

  try {
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.error('Error fetching upcoming events:', err);
    return { count: 0, items: [] };
  }
};
